import { Flex } from 'antd';
import React, { memo, ReactNode } from 'react';

interface IWrapperTwoColumn {
    childFirstColumn: ReactNode;
    childSecondColumn: ReactNode;
    style: React.CSSProperties;
}

const WrapperTwoColumn: React.FC<IWrapperTwoColumn> = ({ childFirstColumn, childSecondColumn, style }) => {
    return (
        <Flex justify={'space-between'} gap={20} style={style}>
            <Flex vertical style={{ width: '50%' }}>
                {childFirstColumn}
            </Flex>
            <Flex vertical style={{ width: '50%' }}>
                {childSecondColumn}
            </Flex>
        </Flex>
    );
};

export default memo(WrapperTwoColumn);
